import { Typography } from "antd";
import { ConsentStatusType } from "../../Utils/Constants/consentTypes";

export const activityDescription = (type: string, jsonString: string) => {
  const json = JSON.parse(jsonString);

  const { Text } = Typography;

  switch (type) {
    case "ACCOUNT_DELINK":
      return (
        <>
          <Text className="type">FIP : </Text>
          <Text className="value" type="secondary">
            {json?.fip?.name}
          </Text>
          <br />
        </>
      );

    case "AA_UPDATE_CONSENT_APPROVAL_STATUS":
    case "AA_UPDATE_CONSENT_APPROVAL_STATUS_ACCOUNT":
      return (
        <>
          <Text className="type">Authtype : </Text>
          <Text className="value" type="secondary">
            {json.authType}
          </Text>
          <br />
        </>
      );

    case "AA_UPDATE_CONSENT_STATUS":
    case "AA_UPDATE_CONSENT_STATUS_ACCOUNT":
      return (
        <>
          <Text className="type">Status : </Text>
          <Text className="value" type="secondary">
            {json.consentStatusType}
          </Text>
          <br />
          <Text className="type">FIU : </Text>
          <Text className="value" type="secondary">
            {json.fiu.name}
          </Text>
        </>
      );

    case "AA_STORE_CREATE_CONSENT_REQUEST":
      return (
        <>
          <Text className="type">Status : </Text>
          <Text
            style={{ color: "#000000", opacity: 0.5, fontWeight: "bold" }}
            type="secondary"
          >
            {json.consentApprovalStatusType}
          </Text>
          <br />
          <Text className="type">FIU : </Text>
          <Text className="value" type="secondary">
            {json.fiu.name}
          </Text>
        </>
      );
    case "AA_STORE_ACCOUNT_LINK_UPDATE":
      return (
        <>
          <Text className="type">MaskedAccNumber : </Text>
          <Text className="value" type="secondary">
            {json.maskedAccNumber}
          </Text>
          <br />
          <Text className="type">Account Type : </Text>
          <Text className="value" type="secondary">
            {json.accountType}
          </Text>
          <br />
          <Text className="type">FIP : </Text>
          <Text className="value" type="secondary">
            {json.fip.name}
          </Text>
        </>
      );
    case "AA_FIP_ACCOUNT_DISCOVERY":
      return (
        <>
          {json.fip && (
            <>
              <Text className="type">FIP : </Text>
              <Text className="value" type="secondary">
                {json.fip?.name}
              </Text>
              <br />
            </>
          )}
        </>
      );

    case "AA_STORE_SAVE_FI_REQUEST":
    case "AA_STORE_SAVE_FI_REQUEST_ACCOUNT":
      return (
        <>
          <Text className="type">Expire On : </Text>
          <Text className="value" type="secondary">
            {new Date(json.FIDataRange.expiry).toDateString().slice(4)}
          </Text>
          <br />
        </>
      );
    case "AA_PURGE_FI_DATA_FETCHED":
    case "AA_PURGE_FI_DATA_EXPIRE":
    case "AA_PURGE_FI_DATA_FETCHED_ACCOUNT":
    case "AA_PURGE_FI_DATA_EXPIRE_ACCOUNT":
      return (
        <>
          {json.fipId ? (
            <>
              <Text className="type">Fip : </Text>
              <Text className="value" type="secondary">
                {json.fipId}
              </Text>
            </>
          ) : (
            <></>
          )}

          {json.maskedAccRefNumber ? (
            <>
              <br />
              <Text className="type">Account : </Text>
              <Text className="value" type="secondary">
                {json.maskedAccRefNumber}
              </Text>
            </>
          ) : (
            <></>
          )}
        </>
      );
    case "AA_FI_DATA_FETCH":
    case "FIU_FI_DATA_FETCH":
    case "AA_FI_DATA_FETCH_ACCOUNT":
    case "FIU_FI_DATA_FETCH_ACCOUNT":
      return (
        <>
          {json.fipId ? (
            <>
              <Text className="type">FIP Id : </Text>
              <Text className="value" type="secondary">
                {json.fipId}
              </Text>
              <br />
            </>
          ) : (
            <></>
          )}

          {json?.accountInfo && (
            <div style={{ display: "flex" }}>
              <Text className="type">Accounts : </Text>
              <div style={{ display: "flex", flexWrap: "wrap", flex: "70%" }}>
                {json?.accountInfo?.map((account: any, index: number) => (
                  <>
                    <Text className="value" type="secondary">
                      {account.maskedAccNumber}{" "}
                      {index + 1 === json?.accountInfo?.length ? "" : " ,"}
                    </Text>
                    <br />
                  </>
                ))}
              </div>
            </div>
          )}
        </>
      );
    default:
      return null;
  }
};

export const activityTitle = (type: string, jsonString: string, t: any) => {
  const json = JSON.parse(jsonString);

  switch (type) {
    case "AA_UPDATE_CONSENT_APPROVAL_STATUS":
    case "AA_UPDATE_CONSENT_APPROVAL_STATUS_ACCOUNT":
      return (
        <Typography.Text
          className={
            `${json.constentApprovalStatus === "APPROVED" || json.constentApprovalStatus === "READY"}`
              ? "successColor"
              : "dangerColor"
          }
        >
          {t(type)}{" "}
          {json.constentApprovalStatus === "APPROVED" || json.constentApprovalStatus === "READY" ? "Approved" : "Rejected"}{" "}
        </Typography.Text>
      );

    case "AA_UPDATE_CONSENT_STATUS":
    case "AA_UPDATE_CONSENT_STATUS_ACCOUNT":
      return (
        <Typography
          style={{
            color:
              json.consentStatusType === ConsentStatusType.ACTIVE
                ? "var(--ant-success-color)"
                : "var(--ant-primary-color)",
          }}
        >
          {json.consentStatusType === ConsentStatusType.ACTIVE ? (
            t(type) + t(" Reactivated")
          ) : (
            <Typography.Text
              style={{
                color:
                  json.consentStatusType === ConsentStatusType.ACTIVE
                    ? "var(--ant-success-color)"
                    : "var(--ant-primary-color)",
              }}
            >
              {t(type)}{" "}
              <Typography.Text
                style={{
                  fontWeight: "bold",
                  color:
                    json.consentStatusType === ConsentStatusType.ACTIVE
                      ? "var(--ant-success-color)"
                      : "var(--ant-primary-color)",
                }}
              >
                {json.consentStatusType}
              </Typography.Text>
            </Typography.Text>
          )}
        </Typography>
      );

    case "AA_STORE_CREATE_CONSENT_REQUEST":
      return (
        <Typography.Text className="primaryColor">
          {t(type)} by {json.fiu?.name}
        </Typography.Text>
      );
    case "AA_STORE_ACCOUNT_LINK_UPDATE":
      return (
        <>
          <Typography
            style={{
              color:
                json.accountStatusType === "LINKED"
                  ? "var(--ant-success-color)"
                  : "var(--ant-danger-color)",
            }}
          >
            {t("account")}{" "}
            <Typography.Text
              style={{
                color:
                  json.accountStatusType === "LINKED"
                    ? "var(--ant-success-color)"
                    : "var(--ant-danger-color)",
                fontWeight: "bold",
              }}
            >
              {json.accountStatusType}{" "}
            </Typography.Text>
            {t("success")}
          </Typography>
        </>
      );
    case "AA_FIP_ACCOUNT_DISCOVERY":
      return <Typography className="primaryColor">{t(type)}</Typography>;

    case "AA_STORE_OTP":
      return <Typography className="primaryColor">{t(type)}</Typography>;

    case "ACCOUNT_DELINK":
      return <Typography.Text type="danger">{t(type)}</Typography.Text>;
    case "AA_STORE_SAVE_FI_REQUEST":
    case "AA_STORE_SAVE_FI_REQUEST_ACCOUNT":
      return (
        <Typography.Text className="primaryColor">{t(type)}</Typography.Text>
      );
    case "AA_PURGE_FI_DATA_FETCHED":
    case "AA_PURGE_FI_DATA_FETCHED_ACCOUNT":
      return (
        <Typography.Text className="font14 fontWeight600">
          {`Data has been purged by AA`}
        </Typography.Text>
      );
    case "AA_PURGE_FI_DATA_EXPIRE":
    case "AA_PURGE_FI_DATA_EXPIRE_ACCOUNT":
      return (
        <Typography.Text className="font14 fontWeight600">
          Data has been expired
        </Typography.Text>
      );
    case "AA_FI_DATA_FETCH":
    case "AA_FI_DATA_FETCH_ACCOUNT":
      return (
        <Typography.Text className="font14 fontWeight600">
          {`Data has been fetched by AA from ${json?.fipId ?? "FIP"}`}
        </Typography.Text>
      );
    case "FIU_FI_DATA_FETCH":
    case "FIU_FI_DATA_FETCH_ACCOUNT":
      return (
        <Typography.Text className="font14 fontWeight600">
          {`Data has been transfered to ${json.fiuId ?? "FIU"}`}
        </Typography.Text>
      );
    default:
      return null;
  }
};
